<template>
    <div
        class="modal modal-confirm fade"
        ref="modal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ title }}
                    </h5>
                </div>
                <div class="modal-body" v-html="msg"></div>
                <div class="modal-footer">
                    <div class="btn-group">
                        <button
                            type="button"
                            class="btn btn-close"
                            @click="cancel"
                            v-show="isShowCancelBtn"
                        >
                            取消
                        </button>
                        <button
                            type="button"
                            class="btn btn-ok"
                            @click="submit"
                        >
                            {{ submitBtnText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    props: {
        msg: {
            type: String,
            required: true,
        },
        // 開關控制 true: 開, false: 關
        triggerOpen: {
            type: Boolean,
            default: false,
        },
        // submit按鈕文字
        submitBtnText: {
            type: String,
            default: '我知道了',
        },
        callback: {
            default: null,
        },
        isShowCancelBtn: {
            default: false,
        },
        title: {
            type: String,
            default: '通知',
        },
    },
    data() {
        return {};
    },
    mounted() {
        //
        $(this.$refs.modal).on('show.bs.modal', () => {
            $(this.$refs.modal).css(
                'z-index',
                1050 + document.querySelectorAll('.modal.show').length,
            );
        });
        $(this.$refs.modal).on('hidden.bs.modal', () => {
            $(this.$refs.modal).css('z-index', 1050);
        });
    },
    methods: {
        /**
         * toggle modal
         */
        toggleAlertModal() {
            $(this.$refs.modal).modal('toggle');
        },
        /**
         * submit method
         */
        submit() {
            this.toggleAlertModal();
            if (this.callback) {
                this.callback();
            }
        },
        cancel() {
            this.toggleAlertModal();
        },
    },
    watch: {
        triggerOpen() {
            this.toggleAlertModal();
        },
    },
};
</script>

<style>

</style>
